export const setUserObj = payload => ({
    type: 'SET_USER',
    payload
})

export const signOutUser = () => ({
    type: 'SIGNOUT_USER'
})

